"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labels = void 0;
var labels = {
  he: {
    cet: 'המרכז לטכנולוגיה חינוכית',
    he: 'עברית',
    ar: 'العربيه',
    en: 'English',
    login: 'להתחברות',
    home_page_subscription: 'לרכישת מינוי מוסדי',
    home_purchase_link: 'https://www.cet-catalogue.cet.ac.il/digital-forms',
    technical_support: 'תמיכה והדרכה',
    technical_support_link: 'https://lo.cet.ac.il/player/?document=8cc8973b-8a06-4410-8e2c-c241a6968a45&language=he&options=nobar',
    no_notifications: 'אין לנו מה לחדש לך כרגע',
    view_my_profile: 'אזור אישי',
    logout: 'התנתקות',
    select_language: 'בחר שפה',
    change_user_role: 'החלפת בית ספר'
  },
  ar: {
    cet: 'مركز التكنولوجيا التربويّة',
    he: 'עברית',
    ar: 'العربيه',
    en: 'English',
    login: 'اشبك',
    home_page_subscription: 'لشراء اشتراك',
    home_purchase_link: 'https://www.cet-catalogue.cet.ac.il/digital-forms-ar',
    technical_support: 'دعم ومساعدة',
    technical_support_link: 'https://lo.cet.ac.il/player/?document=8cc8973b-8a06-4410-8e2c-c241a6968a45&language=he&options=nobar',
    no_notifications: 'حاليًّا، لا جديد لدينا لك',
    view_my_profile: 'منطقة شخصيّة',
    logout: 'افصل',
    select_language: 'اختر لغة',
    change_user_role: 'استبدال المدرسة'
  },
  en: {
    cet: 'המרכז לטכנולוגיה חינוכית',
    he: 'עברית',
    ar: 'العربيه',
    en: 'English',
    login: 'Login',
    home_page_subscription: 'לרכישת מינוי מוסדי',
    home_purchase_link: 'https://www.cet-catalogue.cet.ac.il/digital-forms',
    technical_support: 'תמיכה והדרכה',
    technical_support_link: 'https://lo.cet.ac.il/player/?document=8cc8973b-8a06-4410-8e2c-c241a6968a45&language=he&options=nobar',
    no_notifications: 'אין לנו מה לחדש לך כרגע',
    view_my_profile: 'אזור אישי',
    logout: 'התנתקות',
    select_language: 'Select language',
    change_user_role: 'החלפת בית ספר'
  }
};
exports.labels = labels;